import { injectCpmsBoTokenApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-token.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTokenApi = injectCpmsBoTokenApi(baseApi);

export const {
  useCpmsBoGetTokenQuery,
  useCpmsBoGetTokensPaginatedQuery,
  useCpmsBoDeleteTokenMutation,
  useCpmsBoCreateTokenMutation,
  useCpmsBoUpdateTokenMutation,
} = cpmsBoTokenApi;
